// HERE WE STORE THE TOKEN OF USER WHICH WE USE TO PASS THROUGH PROTECTED API'S IN ITS HEADER

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userToken: null,
    userDetails: null,
}

const userTokenSlice = createSlice({
    name: "userTokenSlice",
    initialState,
    reducers: {
        setUserToken: (state, action) => {
            state.userToken = action.payload;
            return state;
        },
        setUserDetails:(state,action)=>{
            state.userDetails=action.payload;
            return state;
        },
        removeUserToken: (state, action) => {
            state.userToken = null;
            state.userDetails = null;
            return state;
        }
    }

});

export const { setUserToken, removeUserToken,setUserDetails } = userTokenSlice.actions;
export default userTokenSlice;